export default __webpack_public_path__ + "static/media/icon-services.5f433295.svg";